import { useState, useCallback, useEffect } from "react";

let logoutTimer;

export const useAuth = () => {
  const [token, setToken] = useState(false);

  const [tokenExpirationDate, setTokenExpirationDate] = useState();

  const [userId, setUserId] = useState(false);

  const [userRole, setUserRole] = useState(false);

  const [userName, setUserName] = useState(false);

  const [userFacultate, setUserFacultate] = useState(false);

  const login = useCallback(
    (uid, token, userRole, userName, userFacultate, expirationDate) => {
      setToken(token);

      setUserId(uid);

      setUserRole(userRole);

      setUserName(userName);

      setUserFacultate(userFacultate);

      const tokenExpirationDate =
        //expiration
        expirationDate || new Date(new Date().getTime() + 1000 * 60 * 60 * 8);

      setTokenExpirationDate(tokenExpirationDate);

      localStorage.setItem(
        "userData",

        JSON.stringify({
          userId: uid,

          token: token,

          userRole: userRole,

          userName: userName,

          userFacultate: userFacultate,

          expiration: tokenExpirationDate.toISOString(),
        })
      );
    },

    []
  );

  const logout = useCallback(() => {
    setToken(null);

    setTokenExpirationDate(null);

    setUserId(null);

    setUserRole(null);

    setUserName(null);

    setUserFacultate(null);

    localStorage.removeItem("userData");
  }, []);

  useEffect(() => {
    if (token && tokenExpirationDate) {
      const remainingTime =
        tokenExpirationDate.getTime() - new Date().getTime();

      logoutTimer = setTimeout(logout, remainingTime);
    } else {
      clearTimeout(logoutTimer);
    }
  }, [token, logout, tokenExpirationDate]);

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("userData"));

    if (
      storedData &&
      storedData.token &&
      new Date(storedData.expiration) > new Date()
    ) {
      login(
        storedData.userId,

        storedData.token,

        storedData.userRole,

        storedData.userName,

        storedData.userFacultate,

        new Date(storedData.expiration)
      );
    }
  }, [login]);

  return { token, login, logout, userId, userRole, userName, userFacultate };
};
